export const logoutNRLAccount = () => {
	const nrl_auth_logout_url =
		process.env.REACT_APP_NRL_URL +
		'/account/logout?post_logout_redirect_uri=' +
		process.env.REACT_APP_ABSPATH
	;
	window.location.assign(nrl_auth_logout_url);
};

export default logoutNRLAccount;


// WEBPACK FOOTER //
// ./src/utils/auth/logoutNRLAccount.js